// extracted by mini-css-extract-plugin
module.exports = {"modal":"LoginModal_modal__1affo","section":"LoginModal_section__1Jm1d","close":"LoginModal_close__f8OQ1"};